import CheckInFirstNameConflictModal from './CheckInFirstNameConflictModal';

export default CheckInFirstNameConflictModal;
